/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceCheckoutRequest
 */
export interface InvoiceCheckoutRequest {
    /**
     * 
     * @type {number}
     * @memberof InvoiceCheckoutRequest
     */
    customerId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof InvoiceCheckoutRequest
     */
    packageIds: number[];
    /**
     * 
     * @type {number}
     * @memberof InvoiceCheckoutRequest
     */
    cashCollected: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceCheckoutRequest
     */
    bankTransfer: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceCheckoutRequest
     */
    creditCard: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceCheckoutRequest
     */
    discount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceCheckoutRequest
     */
    pointsToRemove: number;

    /**
     * 
     * @type {number}
     * @memberof InvoiceCheckoutRequest
     */
    creditBalanceToRemove: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceCheckoutRequest
     */
    referenceNumber: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceCheckoutRequest
     */
    cashierId?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceCheckoutRequest
     */
    courierId?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceCheckoutRequest
     */
    collectedBy: string;

    signature?: string;
}

/**
 * Check if a given object implements the InvoiceCheckoutRequest interface.
 */
export function instanceOfInvoiceCheckoutRequest(value: object): value is InvoiceCheckoutRequest {
    let requiredFields = [
        'customerId',
        'packageIds',
        'cashCollected',
        'bankTransfer',
        'creditCard',
        'discount',
        'pointsToRemove',
        'creditBalanceToRemove',
        'referenceNumber',
        'collectedBy'
    ];
    return requiredFields.every(field => field in value && value[field as keyof typeof value] !== undefined);
}

export function InvoiceCheckoutRequestFromJSON(json: any): InvoiceCheckoutRequest {
    return InvoiceCheckoutRequestFromJSONTyped(json, false);
}

export function InvoiceCheckoutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceCheckoutRequest {
    if (json == null) {
        return json;
    }
    return {
        'customerId': json['customerId'],
        'packageIds': json['packageIds'],
        'cashCollected': json['cashCollected'],
        'bankTransfer': json['bankTransfer'],
        'creditCard': json['creditCard'],
        'discount': json['discount'],
        'pointsToRemove': json['pointsToRemove'],
        'creditBalanceToRemove': json['creditBalanceToRemove'],
        'referenceNumber': json['referenceNumber'],
        'cashierId': json['cashierId'],
        'courierId': json['courierId'],
        'collectedBy': json['collectedBy'],
        'signature': json['signature'],
    };
}

export function InvoiceCheckoutRequestToJSON(json: any): InvoiceCheckoutRequest {
    return InvoiceCheckoutRequestToJSONTyped(json, false);
}

export function InvoiceCheckoutRequestToJSONTyped(value?: InvoiceCheckoutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        'customerId': value['customerId'],
        'packageIds': value['packageIds'],
        'cashCollected': value['cashCollected'],
        'bankTransfer': value['bankTransfer'],
        'creditCard': value['creditCard'],
        'discount': value['discount'],
        'pointsToRemove': value['pointsToRemove'],
        'creditBalanceToRemove': value['creditBalanceToRemove'],
        'referenceNumber': value['referenceNumber'],
        'cashierId': value['cashierId'],
        'courierId': value['courierId'],
        'collectedBy': value['collectedBy'],
        'signature': value['signature'],
    };
}

